import { Component, OnInit, ViewChild, Input, ElementRef, Output, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, ViewChildren, QueryList, ContentChildren } from '@angular/core';

@Component({
  selector: 'app-view-stack-view',
  templateUrl: './view-stack-view.component.html',
  styleUrls: ['./view-stack-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewStackViewComponent implements AfterViewInit {
  private initialized: boolean = false;
  public isSticky: boolean = false;
  @Input() set sticky(sticky: string) {
    this.isSticky = true;
  }
  public isStickyUnfit: boolean = false;
  @Input() set unfit(sticky: string) {
    this.isStickyUnfit = true;
  }
  public isLazy: boolean = false;
  @Input() set lazy(isLazy: string) {
    this.isLazy = true;
  }
  private isFit = false;
  @Input() set fit(isFit:string) {
    this.isFit = true;
  }
  private _noGrow = false;
  @Input('no-grow') set noGrow(grow:string) {
    this._noGrow = true;
  }
  @HostBinding('attr.data-var') varName: string = '';
  public get viewVariable(): string {
    return this.varName;
  }
  get element(): ElementRef {
    return this.domNode;
  }
  // tslint:disable-next-line: no-input-rename
  private _viewName: string = '';
  @Input() set viewName(viewName: string) {
    this._viewName = viewName;
    if (this.initialized === true) {
      this.cdr.detectChanges();
    }
  }
  get viewName(): string {
    return this._viewName;
  }
  @Input() showInNav = true;
  @Output() dataset: any;
  constructor(private domNode: ElementRef<HTMLElement>, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.dataset = this.domNode.nativeElement.dataset;
    if (this.varName === null) {
      this.varName = '';
    }
    this.initialized = true;
    this.cdr.detectChanges();
  }

  ToggleActive(onOff: boolean) {
    this.domNode.nativeElement.classList.toggle('active', onOff);
    this.cdr.detectChanges();
  }
  IsActive(): boolean {
    return this.domNode.nativeElement.classList.contains('active');
  }
  IsShowable(): boolean {
    if (this.isLazy) {
      return !this.IsActive();
    }
    return true;
  }

}
